import useSWR from 'swr';

import keycloakService from '../../../../keycloak_service';

import { postToSinatra } from '../../../../utils/api_utils';

export const fetchPipelines = () => {
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify({}),
  };

  return postToSinatra('v1/api/pipelines/list_pipelines', fetchOptions)
}

export const useListPipelines = (disablePolling = false) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR('admin-pipeline-list', fetchPipelines, {
    refreshInterval: disablePolling ? 0 : 3000,
    loadingTimeout: 1000,
  });

  return {
    data: data?.pipelines,
    error,
    isLoading,
  }
}

export default useListPipelines;
